export const runtimeEnvironment = {
  BUILD_NUMBER: 'be0c3f79-c376-47a1-b156-ed8483a7b615',
  SENTRY_ENABLED: true,
  MPESA_TOKEN: 'X1S44WEuqoMH3VCx',
};
